// extracted by mini-css-extract-plugin
export default {"ManualKeywordEditBoard":"manualKeywordEditBoard_ManualKeywordEditBoard__dZim4","search-bar":"manualKeywordEditBoard_search-bar__jStim"};